var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.89736 33C12.4689 33 14.8882 31.9983 16.7065 30.18L30.4482 16.4403C32.2509 14.6318 33.263 12.1823 33.2626 9.62879C33.2622 7.07528 32.2494 4.62609 30.4462 2.81809C29.5535 1.92151 28.4919 1.21082 27.3228 0.72711C26.1537 0.243402 24.9003 -0.00371783 23.6351 4.22723e-05C21.0636 4.22723e-05 18.6462 1.00167 16.8279 2.82002L3.08627 16.5597C1.28399 18.3682 0.271846 20.8172 0.271484 23.3704C0.271123 25.9236 1.28258 28.3729 3.08434 30.1819C3.97739 31.0785 5.03933 31.7893 6.20875 32.273C7.37816 32.7567 8.63186 33.0038 9.89736 33ZM19.5496 5.54369C20.0847 5.00583 20.7211 4.57942 21.422 4.28913C22.123 3.99883 22.8745 3.85042 23.6332 3.85247C25.178 3.85247 26.6304 4.45345 27.7206 5.54369C28.8029 6.62817 29.4109 8.09762 29.4113 9.62976C29.4116 11.1619 28.8043 12.6316 27.7226 13.7166L22.15 19.2872L13.979 11.1124L19.5496 5.54369Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.75fd3f545278ac2dc5f8c3d9a781c874.svg";
export { ForwardRef as ReactComponent };